/**
 * Notification popup.
 *
 * Call it through the shared service Loader.
 */
angular.module('hjApp').directive('loader', [
    '$rootScope',
    '$timeout',
    function ($rootScope, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            template:
                /* eslint-disable max-len */
                '<div class="notification-box notification-box-loader {{ boxClass }}">' +
                '<div class="notification-overlay"></div>' +
                '<div class="notification-box-content box-shadow"><div class="spinner"></div><div ng-show="message" class="text">{{ message }}</div></div>' +
                '</div>',
            /* eslint-enable max-len */
            link: function (scope, element) {
                // $emit is triggered from the Loader service.
                $rootScope.$on('hjLoader', function (event, message, action, distanceFromTop) {
                    $timeout(function () {
                        scope.message = message;

                        if (action === 'show') {
                            scope.boxClass = 'notification-box-visible';

                            if (distanceFromTop) {
                                element.css('top', distanceFromTop + 'px');
                                element.css('position', 'absolute');
                            } else {
                                // Show default setting.
                                // We need this to reset the setting in case distanceFromTop was previously set.
                                element.css('top', '35%');
                                element.css('position', 'fixed');
                            }
                        } else {
                            scope.boxClass = '';
                        }
                    });
                });
            }
        };
    }
]);
